var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_67_4420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3662 12.8294C28.5032 10.7445 31.4968 10.7445 32.6338 12.8294L36.4833 19.8878C36.9147 20.679 37.6791 21.2343 38.5648 21.4002L46.4674 22.8801C48.8016 23.3172 49.7266 26.1642 48.0952 27.8898L42.5717 33.7321C41.9526 34.387 41.6607 35.2855 41.7766 36.1792L42.8112 44.1523C43.1168 46.5072 40.6949 48.2668 38.5497 47.2485L31.2865 43.8007C30.4724 43.4142 29.5276 43.4142 28.7135 43.8007L21.4503 47.2485C19.3051 48.2668 16.8832 46.5072 17.1888 44.1523L18.2234 36.1792C18.3393 35.2854 18.0474 34.387 17.4283 33.7321L11.9048 27.8898C10.2734 26.1642 11.1984 23.3172 13.5326 22.8801L21.4352 21.4002C22.3209 21.2343 23.0853 20.679 23.5167 19.8878L27.3662 12.8294Z",
    fill: "#FFD402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6116 35.4496L17.4283 33.7321L15.6116 35.4496C15.7148 35.5588 15.7635 35.7085 15.7442 35.8575L14.7096 43.8306C14.1493 48.148 18.5894 51.3739 22.5224 49.5069L29.7856 46.0592C29.9213 45.9947 30.0787 45.9947 30.2144 46.0592L37.4776 49.5069C41.4106 51.3739 45.8507 48.148 45.2904 43.8306L44.2558 35.8575C44.2365 35.7085 44.2852 35.5588 44.3884 35.4496L49.9118 29.6073C52.9028 26.4437 51.2068 21.2242 46.9276 20.4228L39.025 18.9429C38.8774 18.9153 38.75 18.8227 38.6781 18.6909L34.8286 11.6324C32.7441 7.8102 27.2559 7.81019 25.1714 11.6324L27.255 12.7687L25.1714 11.6324L21.3219 18.6909C21.25 18.8227 21.1226 18.9153 20.975 18.9429L13.0724 20.4228C8.79317 21.2242 7.0972 26.4437 10.0882 29.6073L15.6116 35.4496Z",
    stroke: "white",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_67_4420",
    x: 0.0771484,
    y: 0.265625,
    width: 59.8457,
    height: 58.2869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_67_4420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_67_4420",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar0);
export default __webpack_public_path__ + "static/media/star_0.026d9c33e045391f59d35aa3ebe3ebe8.svg";
export { ForwardRef as ReactComponent };